import { useMutation } from "react-query";

import { httpService } from "utils";

export const useResetPassword = (tokenId: string) => {
  return useMutation((data: FormData) => {
    return resetPassword(data, tokenId);
  });
};

const resetPassword = (formData: FormData, tokenId: string) => {
  return httpService().post(
    `/generate-new-password/${tokenId}`,
    formData
  );
};
